import { EnvironmentId } from '@/react/portainer/environments/types';
import { useStack } from '@/react/common/stacks/queries/useStack';

import { HelmRelease } from '../../types';
import { UpgradeButton } from '../../upgrade/UpgradeButton';

import { RollbackButton } from './RollbackButton';
import { UninstallButton } from './UninstallButton';

type Props = {
  environmentId: EnvironmentId;
  releaseName: string;
  namespace: string;
  latestRevision?: number;
  earlistRevision?: number;
  selectedRevision?: number;
  release?: HelmRelease;
};

export function ChartActions({
  environmentId,
  releaseName,
  namespace,
  latestRevision,
  earlistRevision,
  selectedRevision,
  release,
}: Props) {
  const showRollbackButton =
    latestRevision && earlistRevision && latestRevision > earlistRevision;
  const stackQuery = useStack(release?.stackID);
  const { AutoUpdate: autoUpdate } = stackQuery?.data || {};

  return (
    <div className="inline-flex gap-2 flex-wrap">
      <UpgradeButton
        environmentId={environmentId}
        namespace={namespace}
        release={release}
      />
      {showRollbackButton && (
        <RollbackButton
          latestRevision={latestRevision}
          selectedRevision={selectedRevision}
          environmentId={environmentId}
          releaseName={releaseName}
          namespace={namespace}
          isManagedByGit={!!release?.stackID}
          isGitAutoUpdateOn={!!autoUpdate?.Interval}
        />
      )}
      <UninstallButton
        environmentId={environmentId}
        releaseName={releaseName}
        namespace={namespace}
      />
    </div>
  );
}
